import { atom } from 'jotai';

export const IsModalDraggableAtom = atom(true);
